<template>
  <div>
    <h1 class="text-center pt-12">
      Demo
    </h1>
    <section>
      <v-container>
        <v-row>
          <v-col>
            <div id="video">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <img
                    id="videobild"
                    src="@/assets/demobild.png"
                    alt="Demo för Sunnycloud CRM"
                    v-on="on"
                  >
                </template>
                <span>Demovideo kommer inom kort. Ta kontakt med oss så går vi genom systemet tillsammans</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="pt-sm-12"
          >
            <p>Vill du veta mer, eller ha en personlig genomgång där du har möjlighet att ställa frågor som berör just era behov?</p>
            <p>Fyll i formuläret så hör vi av oss för att planera in ett tillfälle som passar dig.</p>
          </v-col>
          <v-col cols="12" sm="6">
            <v-form>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    id="id"
                    v-model="demodata.firstname"
                    name="firstname"
                    label="Förnamn *"
                    hide-details
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    id="id"
                    v-model="demodata.lastname"
                    name="lastname"
                    label="Efternamn *"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="id"
                    v-model="demodata.email"
                    name="email"
                    label="Email *"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="id"
                    v-model="demodata.phone"
                    name="phone"
                    label="Telefonnummer *"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    id="id"
                    v-model="demodata.name"
                    name="company"
                    label="Företagsnamn *"
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    id="id"
                    v-model="demodata.note"
                    name="description"
                    label="Beskriv gärna lite om era behov"
                    hide-details
                    rows="3"
                    auto-grow
                  />
                </v-col>
                <v-col>
                  <v-btn
                    color="info"
                    :loading="submitting"
                    @click="bookDemo()"
                  >
                    Kontakta mig för demo
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-snackbar
      v-model="snackbar"
      bottom
      vertical
      :color="snackbarType"
      :timeout="10000"
    >
      {{ snackbarText }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Ok
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      recipient: {
        email: 'christoffer@sunnycloud.se',
        site: 'Sunnycloud',
      },
      demodata: {
        org: 'A9J6wfkKxEysB68h1xbQ',
        contact: {},
        company: {},
      },
      snackbarText: '',
      snackbarType: '',
      snackbar: false,

      submitting: false,
    }
  },
  methods: {
    async bookDemo() {
      const demoObject = {
        name: `${this.demodata.firstname} ${this.demodata.lastname} (${this.demodata.name})`,
        phone: this.demodata.phone,
        text: `<br>
          Email: ${this.demodata.email}<br>
          Tel: ${this.demodata.phone}<br><br>

          ${this.demodata.note}
        `,
      }
      this.submitting = true
      const webformDb = 'https://us-central1-sunnycloudplatform.cloudfunctions.net/vuewebform'
      const dataobject = { ...demoObject, ...this.recipient }

      try {
        await axios.post(webformDb, dataobject)

        this.snackbarText = 'Kul att du är intresserad, vi tar kontakt inom kort'
        this.snackbarType = 'success'
        this.snackbar = true
        this.submitting = false
        this.formdata = {}
      } catch (error) {
        this.snackbarText = 'Hmm, nåt gick snett, försök gärna igen'
        this.snackbarType = 'error'
        this.snackbar = true
        this.submitting = false

        this.erroroccurred = true
        console.log('error när vill boka demo', error)
      }
    },
  },
}
</script>script

<style lang='scss' scoped>
  #video {
    text-align: center;
    margin-bottom: 40px;

    img#videobild {
      width: 100%;
      max-width: 600px;
      max-height: 400px;
    }
  }


  p {
    font-size: 22px;
  }
</style>
